<template>

  <div style="height: 100%; overflow-y: auto">

    <avue-divider :column="column" style="display: none"></avue-divider>

    <!--<slot name="divider"></slot>-->
    <!--</el-dialog>-->

    <!--表单页面，用于展示-->
    <!--<el-dialog :visible.sync="formvisible"
                   :modal-append-to-body="false">-->
    <!--加签，减签，撤回，终止按钮点击后的页面-->
    <button-transfer :transfer-info="buttonTransferConf.mainTable" @getModeData="setButtonModeData"></button-transfer>
    <el-dialog :visible.sync="buttonDialog.dialogVisible" :modal="false" :modal-append-to-body="false"
      :title="buttonDialog.title">
      <el-form :rules="rules" ref="buttonForm" :model="buttonDialog">
        <el-form-item v-if="buttonDialog.isAccept" :label="buttonDialog.title+'人：'" label-position="left"
          label-width="100px" prop="acceptUserName">
          <el-input v-if="buttonDialog.key !== 'deleteTask'" v-model="buttonDialog.acceptUserName"
            @focus="inputFocus"></el-input>
          <el-select v-else v-model="buttonDialog.acceptUserName" clearable placeholder="请选择">
            <el-option v-for="item in buttonDialog.acceptUserId" :key="item.taskId" :label="item.assigneeName"
              :value="item.taskId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="display:none;" v-if="buttonDialog.isAccept" :label="buttonDialog.acceptLabel+'：'"
          label-position="left" label-width="100px" prop="acceptUserId">
          <el-input v-model="buttonDialog.acceptUserId"></el-input>
        </el-form-item>
        <el-form-item v-if="buttonDialog.info.length > 0" :label="buttonDialog.title+'：'" label-position="left"
          label-width="100px">
          <div style="font-weight: bold;">{{buttonDialog.info}}</div>
        </el-form-item>
        <el-form-item :label="buttonDialog.label+'：'" label-position="left" label-width="100px">
          <el-input type="textarea" v-model="buttonDialog.reason" :placeholder="buttonDialog.label"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleButtonDialogClose">取消</el-button>
        <el-button type="primary" @click="handleButtonCase">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="stepVisible" :modal-append-to-body="false" title="审批详情">
      <div>
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in stepInfo" :key="index" :timestamp="activity.startTime"
            :type="activity.type" :size="activity.size" placement="top">
            {{activity.taskName}}

            <p v-for="(citem, cindex) in activity.content" :key="cindex">{{citem}}</p>

          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
    <transfer :transfer-info="transferConf.mainTable" @getModeData="setModeData"></transfer>
    <div style="height:100%; background-color: white; padding-top: 10px">
      <div class="button-top">
        <el-button v-if="authButtonDisplay.addTask.display" @click="addTask" type="primary">加签</el-button>
        <el-button v-if="authButtonDisplay.deleteTask.display" @click="deleteTask" type="primary">减签</el-button>
        <el-button v-if="authButtonDisplay.termination.display" @click="terminateTask" type="primary">终止</el-button>
        <el-button v-if="authButtonDisplay.revokePreTask.display" @click="revokePreTask" type="primary">撤回</el-button>
        <el-button v-if="authButtonDisplay.turnTask.display" @click="turnTask" type="primary">转办</el-button>
        <el-button v-if="authButtonDisplay.delegateTask.display" @click="delegateTask" type="primary">委派</el-button>
        <el-button v-if="authButtonDisplay.undoDelegateTask.display" @click="undoDelegateTask"
          type="primary">取消委派</el-button>
        <slot name="save"></slot>
        <slot name="saveAndSubmit"></slot>
        <!--<el-button v-if="!signData.isSign && pageKey === 'DO'" @click="handleSave" type="primary">保存</el-button>
                <el-button v-if="pageKey === 'DO'" type="primary" @click="handleSaveAndSubmit" >保存并提交</el-button>-->
        <el-button size="medium" type="primary" @click="getAuditDetail">查看审批详情</el-button>

        <el-button size="medium" type="danger" @click="$router.go(-1)">返回</el-button>
      </div>
      <div class="drawer-top">
        <h1>{{viewFormData.options.tableComment}}</h1>
      </div>
      <avue-form ref="avueform" class="preview-form bold_input" :option="viewFormData.options"
        v-model="viewFormData.modeldata" :upload-after="uploadAfter" :upload-before="uploadBefore"
        :upload-preview="uploadPreview">

      </avue-form>
    </div>
    <!--</el-dialog>-->

  </div>
</template>


<script>
import { loadJs, changeFormModelUsingTaskForm, controlHideByCondition, uploadBefore, uploadAfter, changeConfigToForm, setMode, donwloadFileOnClick, modifyFormModelData, cascadeLocal } from '@/workFlow/utils/formUtil';
import { getButtonAuthority, initButtonDialog, terminateProcess, revokePreTask, addSign, deleteSign, delegateTask, undoDelegateTask, turnTask } from "@/workFlow/workFlow/flow/util/FlowUtil";
import transfer from '@/workFlow/formComponent/formTransfer/fromtransfer'
import transferConf from '@/workFlow/workFlow/publicConfig/inputConf'
import buttonTransfer from '@/workFlow/formComponent/formTransfer/fromtransfer'
import { deepClone } from "@/framework/util/util";


export default {

  components: { transfer, buttonTransfer },
  props: {
    viewFormData: Object,
  },
  watch: {
    'viewFormData.modeldata': {
      handler(val) {
        if (this.viewFormData.options.jsPath && this.viewFormData.options.jsPath.endsWith('.js')) {
          changeWidgetFormData(val, this.viewFormData.options, this.viewFormData.row, this.viewFormData.pageKey)
        }
        controlHideByCondition(val, this.viewFormData.options)
        cascadeLocal(this.viewFormData.modeldata, this.viewFormData.options, this.$http, this.$message)
      },
      deep: true
    }

  },

  data() {
    return {
      viewFormData: {
        options: {},
        modeldata: {},
        pageKey: '',
        row: {}
      },
      column: {
        dalign: 'center',
      },
      stepInfo: [],
      stepVisible: false,
      authButtonDisplay: {
        addTask: {
          display: false,
          info: []
        },
        deleteTask: {
          display: false,
          info: []
        },
        termination: {
          display: false,
          info: []
        },
        revokePreTask: {
          display: false,
          info: []
        },
        turnTask: {
          display: false,
          info: []
        },
        delegateTask: {
          display: false,
          info: []
        },
        undoDelegateTask: {
          display: false,
          info: []
        }
      },
      buttonDialog: {
        key: '',
        dialogVisible: false,
        reason: '',
        title: '',
        label: '',
        info: '',
        acceptUserId: '',
        isAccept: false,
        acceptLabel: '',
        acceptUserName: ''
      },
      rules: {
        acceptUserName: [
          { required: true, message: `请填写`, trigger: 'blur' }
        ]
      },
      transferConf,
      buttonTransferConf: deepClone(transferConf)
    }
  },

  mounted() {
    changeConfigToForm(document.getElementsByTagName('label'), this.viewFormData.options)
    setTimeout(() => {
      donwloadFileOnClick(this.$refs.avueform, this.$downloadFile, this.viewFormData.modeldata, this.$message)
    }, 600)
  },
  created: function () {

    modifyFormModelData(this.viewFormData.options, this.transferConf)
    getButtonAuthority(this.authButtonDisplay, this.$http, this.$message, this.viewFormData.pageKey, this.viewFormData.modeldata)
  },
  methods: {
    uploadPreview(file, column) {
      console.log(file)
      console.log(column)
      console.log('uploadPreview')
    },

    setButtonModeData(modeData) {
      console.log('hello modeldata')
      console.log(modeData)
      this.buttonDialog.acceptUserId = modeData.id
      this.buttonDialog.acceptUserName = modeData.name

    },
    inputFocus() {
      console.log('hello focus')
      this.buttonTransferConf.mainTable.buttonSetting.modeConf.title = this.buttonDialog.title + '人选择'
      this.buttonTransferConf.mainTable.buttonSetting.modeConf.doubleClick = false
      this.buttonTransferConf.mainTable.buttonSetting.modeConf.toLabel = ''
      this.buttonTransferConf.mainTable.buttonSetting.modeConf.urlStr = '/user-info/xyybs'
      this.buttonTransferConf.mainTable.buttonSetting.visible = true
      console.log(this.transferConf.mainTable.buttonSetting.visible)
    },
    setModeData(modeData, modeProp) {
      setMode(modeData, this.viewFormData.options, this.viewFormData.modeldata, this.transferConf.mainTable, modeProp)
    },
    uploadBefore(file, done, loading, column) {
      uploadBefore(file, done, loading, column, this.$message)
    },
    uploadAfter(ress, done, loading, column) {
      uploadAfter(ress, done, loading, column, this.viewFormData.modeldata, this.$downloadFile, this.$message)
    },
    handleBeforeClose() {
      this.$emit('formClose')
    },
    handleButtonDialogClose() {
      this.buttonDialog.dialogVisible = false
    },
    handleButtonCase() {
      this.$refs.buttonForm.validate((valid) => {
        if (valid) {
          if (this.buttonDialog.key === 'termination')//终止事件
            terminateProcess(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay)
          else if (this.buttonDialog.key === 'revokePreTask')//撤回事件
            revokePreTask(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay)
          else if (this.buttonDialog.key === 'addTask')//加签
            addSign(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay, false)
          else if (this.buttonDialog.key === 'deleteTask')//减签
            deleteSign(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay, false)
          else if (this.buttonDialog.key === 'delegateTask')//委派事件
            delegateTask(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay)
          else if (this.buttonDialog.key === 'turnTask')//转办事件
            turnTask(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay)
          else if (this.buttonDialog.key === 'undoDelegateTask')//取消委派
            undoDelegateTask(this.$http, this.$message, this.viewFormData.modeldata, this.buttonDialog, this.authButtonDisplay)
        } else {
          return false
        }
      })

    },
    addTask() {
      initButtonDialog(this.buttonDialog, 'addTask', "加签原因", '加签', "加签人ID", true)

    },
    deleteTask() {
      console.log(this.authButtonDisplay)
      this.$http.get('/flow-task-change/delete-task-list', { params: { 'processInstanceId': this.viewFormData.modeldata.processInstanceId, 'taskDefKey': this.authButtonDisplay.deleteTask.info } }).then(
        response => {
          this.buttonDialog.acceptUserId = response.data
          console.log('hello usename')
          console.log(this.buttonDialog.acceptUserId)
          initButtonDialog(this.buttonDialog, 'deleteTask', "减签原因", '减签', '', true)
        }
      ).catch(err => {
        if (err.msg)
          this.$message.error(err.msg)
        else
          this.$message.error(err.message)
      })


    },
    terminateTask() {
      console.log('viewform')
      console.log(this.viewFormData.modeldata)
      initButtonDialog(this.buttonDialog, 'termination', "终止原因", '终止', '', false)
    },
    revokePreTask() {
      initButtonDialog(this.buttonDialog, 'revokePreTask', "撤回原因", '撤回', '', false)
      if (this.authButtonDisplay.revokePreTask) {
        if (this.authButtonDisplay.revokePreTask.info) {
          if (this.authButtonDisplay.revokePreTask.info.preTaskInfo && this.authButtonDisplay.revokePreTask.info.preTaskInfo.length > 0) {
            for (let i = 0; i < this.authButtonDisplay.revokePreTask.info.preTaskInfo.length; i++) {
              if (i === this.authButtonDisplay.revokePreTask.info.preTaskInfo.length - 1) {
                if (this.buttonDialog.info.indexOf(this.authButtonDisplay.revokePreTask.info.preTaskInfo[i].taskName) === -1) {
                  this.buttonDialog.info += this.authButtonDisplay.revokePreTask.info.preTaskInfo[i].taskName
                }

              }
              else {
                if (this.buttonDialog.info.indexOf(this.authButtonDisplay.revokePreTask.info.preTaskInfo[i].taskName) === -1) {
                  this.buttonDialog.info += this.authButtonDisplay.revokePreTask.info.preTaskInfo[i].taskName + ","
                }
              }

            }
          }
        }
      }
    },
    undoDelegateTask() {
      initButtonDialog(this.buttonDialog, 'undoDelegateTask', "撤销委派原因", '撤销委派', '', false)
    },
    delegateTask() {
      initButtonDialog(this.buttonDialog, 'delegateTask', "委派原因", '委派', "委派人ID", true)
    },
    turnTask() {//转办时需要选择acceptId
      initButtonDialog(this.buttonDialog, 'turnTask', "转办原因", '转办', "转办人ID", true)
    },
    getAuditDetail() {//流程流转详情查询
      this.$http.get('/flow-info/detail', {
        params: {
          'processInstanceId': this.viewFormData.modeldata.processInstanceId,
          'showFirstModifyRecord': false, 'showRepotModifyRecord': false
        }
      }).then(response => {
        if (response.code === 200) {
          this.stepInfo = response.data
          this.handleStepInfo(this.stepInfo)
          this.stepVisible = true
        } else {
          this.$message.error(response.code + response.msg)
        }
      }).catch(error => {
        if (error.msg)
          this.$message.error(error.msg)
        else
          this.$message.error(error.message)
      })
    },
    handleStepInfo(stepInfo) {
      if (stepInfo && stepInfo.length > 0) {
        for (let i = 0; i < stepInfo.length; i++) {
          if (stepInfo[i].endTime) {//有结束时间，则该环节审核已完成
            stepInfo[i].type = 'success'
            stepInfo[i].content = []
            stepInfo[i].taskName = stepInfo[i].taskName
            stepInfo[i].content.push("审核人：" + stepInfo[i].assigneeName)

            if (stepInfo[i].modifyContent.length > 0) {//对表单操作数据，将数据变化展示
              for (let j = 0; j < stepInfo[i].modifyContent.length; j++) {
                if (!stepInfo[i].modifyContent[j].executeValueOld) {//没有旧值
                  stepInfo[i].content.push(stepInfo[i].modifyContent[j].executeFieldLabel + "：" + stepInfo[i].modifyContent[j].executeValueText);
                } else {//有旧值
                  stepInfo[i].content.push(stepInfo[i].modifyContent[j].executeFieldLabel + "：" + stepInfo[i].modifyContent[j].executeValueOldText +
                    "改为" + stepInfo[i].modifyContent[j].executeValueText)
                }
              }
            }
            stepInfo[i].content.push("审核结束时间：" + stepInfo[i].endTime)
          } else {
            stepInfo[i].size = 'large'
            stepInfo[i].taskName = stepInfo[i].taskName
            stepInfo[i].content = []
            stepInfo[i].content.push("审核人：" + stepInfo[i].assigneeName)
          }
        }
      }

    },
  }

}


</script>
<style lang="scss" scoped>
:deep(.drawer-foot) {
  position: absolute;
  /*bottom: 0;
        left: 0;
        right: 0;*/
  margin-top: 20px;
  //display: flex;

  button {
    width: 50%;
  }
}

.audit_step {
  position: absolute;
  top: 150px;
  right: 10px;
  left: 820px;
  margin-bottom: 10px;
  background-color: white;
  z-index: 90;
}

.button-top {
  text-align: right;
  position: absolute;
  top: 35px;
  right: 23px;
  display: flex;
  z-index: 90;
}

.drawer-top {
  position: relative;
  height: 60px;
  margin-top: 50px;
  text-align: center;
}

:deep(.preview-form) {
  padding-top: 20px;
  /*overflow-y: auto;*/
  padding-bottom: 20px;
  height: 90%;
}
:deep(.avue-crud) {
  padding-bottom: 18px;
}
.bold_input :deep(.el-input__inner) {
  font-weight: bolder !important;
}
:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}
</style>
